import { render, staticRenderFns } from "./PastLeakAlertsTable.vue?vue&type=template&id=b904842c"
import script from "./PastLeakAlertsTable.vue?vue&type=script&lang=js"
export * from "./PastLeakAlertsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports